import React from 'react'

function Dashfooter() {
  return (
    <div>
      <footer className="text-center p-3 bg-light mt-3">
        <p className="mb-0">
          &copy; Cash 365 Days. All Rights Reserved.
        </p>
        {/* <p className="mb-0">
          &copy; {new Date().getFullYear()} Your Company Name. All Rights Reserved.
        </p> */}
      </footer>
    </div>
  )
}
export default Dashfooter
